import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

const SliderIcon = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle cx="12" cy="12" r="12" stroke="#D8DADB" strokeWidth="1" />
        <path d="M14 8.002C14 7.1111 12.9229 6.66493 12.2929 7.2949L8.20711 11.3807C7.81658 11.7712 7.81658 12.4044 8.20711 12.7949L12.2929 16.8807C12.9229 17.5106 14 17.0645 14 16.1736L14 8.002Z" />
    </svg>,
    'slider'
);

export default SliderIcon;
